import React from 'react';
import PropTypes from 'prop-types';
import './AuthForm.css';

const AuthForm = ({ 
  title, 
  submitText, 
  onSubmit, 
  isLoading, 
  error, 
  children,
  footer
}) => {
  return (
    <div className="auth-form-container">
      <div className="auth-form-card">
        <h2 className="auth-form-title">{title}</h2>
        
        {error && (
          <div className="auth-form-error">
            <p>{error}</p>
          </div>
        )}
        
        <form className="auth-form" onSubmit={onSubmit}>
          <div className="auth-form-fields">
            {children}
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary auth-form-submit" 
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : submitText}
          </button>
        </form>
        
        {footer && (
          <div className="auth-form-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

AuthForm.propTypes = {
  title: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node
};

AuthForm.defaultProps = {
  isLoading: false,
  error: '',
  footer: null
};

export default AuthForm;